import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface UserProfile {
  id: string;
  type: 'student' | 'parent';
  firstName?: string | null;
  lastName?: string | null;
  displayName?: string | null;
  preferredName?: string | null;
  gradeLevel?: number | null;
  createdAt: string;
  updatedAt: string;
}

export interface User {
  id: string;
  username: string | null;
  email?: string | null;
  roles: ('student' | 'parent' | 'teacher' | 'admin')[];
  firstName?: string | null;
  lastName?: string | null;
  picture?: string | null;
  grade?: number | null;
  profile?: UserProfile;
  studentId?: string | null;
}

interface AuthState {
  user: User | null;
  token: string | null;
  isAuthenticated: boolean;

  // Actions
  login: (user: User, token: string) => void;
  logout: () => void;
  updateUser: (user: Partial<User>) => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      token: null,
      isAuthenticated: false,

      login: (user, token) => {
        set({
          user,
          token,
          isAuthenticated: true,
        });
      },

      logout: () => {
        set({
          user: null,
          token: null,
          isAuthenticated: false,
        });
      },

      updateUser: (updates) => {
        set((state) => ({
          user: state.user ? { ...state.user, ...updates } : null,
        }));
      },
    }),
    {
      name: 'auth-storage', // localStorage key
      partialize: (state) => ({
        user: state.user,
        token: state.token,
        isAuthenticated: state.isAuthenticated,
      }),
    }
  )
);
